import * as dataStore from './DataStore';
import { performJsonpGetRequest } from "../lib/HttpRequest";
import * as utility from "../utility";
import { mapOtsAvailability } from '@novelist/novum-novella-ui';


const otsDataRetrievedCallback = "otsDataRetrievedCallback";
const buildOtsRequestUrl = (otsResultRelativeUrl) => {
    let profileData = dataStore.getProfileData();
    return `${utility.getNovSchema() + dataStore.getBaseUrl() + otsResultRelativeUrl}?profile=${profileData.Profile}&password=${profileData.Password}`;
}

const getOtsResponse = (url, postAction, otsCallBackComponentName, titleData) => {
  let callback = otsData => {
    titleData.forEach((title) => {
      title.availability = getOtsAvailabilityForTitle(otsData, title.ui);
    });

    postAction(titleData);
  };

  utility.attachFunctionToCallback(callback, otsDataRetrievedCallback + otsCallBackComponentName);

  performJsonpGetRequest(url, otsDataRetrievedCallback + otsCallBackComponentName);

}

const getOtsAvailabilityForTitle = (otsData, titleUi) => {
  if (otsData === null){
    return;
  }

  let otsDataForTitle = otsData.find(titleOts => {
    return titleOts.key === titleUi
  })

  return otsDataForTitle ? mapOtsAvailability(otsDataForTitle) : undefined;
}

export function getOtsAvailabilityDataForTitles(postAction, otsCallBackComponentName, otsResultRelativeUrl, titleData) {
    getOtsResponse(buildOtsRequestUrl(otsResultRelativeUrl), postAction, otsCallBackComponentName, titleData);
}



// WEBPACK FOOTER //
// ./src/data/OtsDataSelector.js